import Link from '~/core/Link'
import { getenv } from '~/settings'

export const OrderDescriptionBeforeSyncForCustomTab = () => {
    return (
        <>
            <p>
                The required customs information form is temporarily not
                available while your order is being processed. This could take
                up to 3 minutes. Once your order is processed, this form will be
                available for you to fill out.
            </p>
            <p>
                For orders where (a) the parts do not meet the prototype
                requirements, or (b) where you do not provide a detailed
                description of the part and parent product/end-use, you will be
                required to act as the Importer of Record and you may be
                assessed duties upon import.
            </p>
            <Link
                href={`${
                    getenv('REGIONAL_CONFIGS')?.urls
                        ?.guide_to_international_shipping_requirements
                }`}
            >
                Learn more about overseas shipping
            </Link>
        </>
    )
}

export const OrderDescriptionBeforeSyncForOrderStatusTab = () => {
    return (
        <p>
            The ordered items are temporarily not available while your order is
            being processed. This could take up upto 3 minutes.
        </p>
    )
}
